<template>
  <vs-row>
    <vs-row class="tblBgClrAdmin shadow-lg mx-4 p-6">
      <!-- Basic Details Section -->

      <vs-row vs-justify="start" class="my-5">
        <vs-col vs-w="12" class="mb-6 borderB pb-4">
          <h2 class="whiteText">Transaction Edit Details</h2>
          <p class="py-4 whiteText">
            Approving this category will increase its points by 0.1 to increase
            its precedence among other liked categories.
          </p>
        </vs-col>
      </vs-row>

      <vs-col vs-w="12" class="mb-6">
        <h3 class="mb-4 whiteText">Basic Information</h3>
        <vs-row>
          <vs-col vs-w="6" class="mb-4">
            <p class="detailLabel">User Name</p>
            <p class="detailContent">
              {{
                transactionEdit.userDetails && transactionEdit.userDetails
                  ? `${transactionEdit.userDetails.firstname} ${transactionEdit.userDetails.lastname}`
                  : "NA"
              }}
            </p>
          </vs-col>

          <vs-col vs-w="6" class="mb-4">
            <p class="detailLabel">Card Name</p>
            <p class="detailContent">
              {{
                transactionEdit.userDetails && transactionEdit.userDetails.card
                  ? transactionEdit.userDetails.card.name
                  : "NA"
              }}
            </p>
          </vs-col>
          <vs-col vs-w="6" class="mb-4">
            <p class="detailLabel">Status</p>
            <p class="detailContent capitalize">{{ transactionEdit.status }}</p>
          </vs-col>
          <vs-col vs-w="6" class="mb-4">
            <p class="detailLabel">Date</p>
            <p class="detailContent">
              {{ formatDate(transactionEdit.createdAt) }}
            </p>
          </vs-col>
        </vs-row>
      </vs-col>

      <!-- Category Changes Section -->
      <vs-col vs-w="12" class="mb-6 borderB pb-4">
        <h4 class="mb-4 whiteText">Category Changes</h4>
        <vs-row>
          <vs-col vs-w="6" class="mb-4">
            <p class="detailLabel">Previous Category</p>
            <p class="detailContent">
              {{
                transactionEdit.prevPointCategory
                  ? transactionEdit.prevPointCategory.name
                  : "NA"
              }}
            </p>
          </vs-col>
          <vs-col vs-w="6" class="mb-4">
            <p class="detailLabel">Current Category</p>
            <p class="detailContent">
              {{
                transactionEdit.pointCategory
                  ? transactionEdit.pointCategory.name
                  : "NA"
              }}
            </p>
          </vs-col>
        </vs-row>
      </vs-col>

      <!-- Multiplier Changes Section -->
      <vs-col vs-w="12" class="mb-6 borderB pb-4">
        <h4 class="mb-4 whiteText">Multiplier Changes</h4>
        <vs-row>
          <vs-col vs-w="6" class="mb-4">
            <p class="detailLabel">Previous Multiplier</p>
            <p class="detailContent">
              {{
                transactionEdit.prevMultiplier
                  ? transactionEdit.prevMultiplier
                  : "NA"
              }}
            </p>
          </vs-col>
          <vs-col vs-w="6" class="mb-4">
            <p class="detailLabel">Current Multiplier</p>
            <p class="detailContent">
              {{
                transactionEdit.multiplier ? transactionEdit.multiplier : "NA"
              }}
            </p>
          </vs-col>
        </vs-row>
      </vs-col>

      <!-- Value Earned Changes Section -->
      <vs-col vs-w="12" class="mb-6 borderB pb-4">
        <h4 class="mb-4 whiteText">Value Earned Changes</h4>
        <vs-row>
          <vs-col vs-w="6" class="mb-4">
            <p class="detailLabel">Previous Value Earned</p>
            <p class="detailContent">
              {{
                transactionEdit.prevValueEarned
                  ? transactionEdit.prevValueEarned
                  : "NA"
              }}
            </p>
          </vs-col>
          <vs-col vs-w="6" class="mb-4">
            <p class="detailLabel">Current Value Earned</p>
            <p class="detailContent">
              {{
                transactionEdit.valueEarned ? transactionEdit.valueEarned : "NA"
              }}
            </p>
          </vs-col>
        </vs-row>
      </vs-col>

      <!-- Action Buttons -->
      <vs-col
        vs-w="12"
        class="mt-6"
        v-if="transactionEdit.status === 'pending'"
      >
        <vs-row vs-justify="end" vs-align="center" vs-type="flex">
          <vs-button
            class="mx-2 px-12 py-4 font-medium"
            color="primary"
            @click="updateStatus('approved')"
          >
            APPROVE
          </vs-button>
          <vs-button
            class="mx-2 px-12 py-4 font-medium"
            color="danger"
            @click="updateStatus('rejected')"
          >
            REJECT
          </vs-button>
        </vs-row>
      </vs-col>
    </vs-row>
  </vs-row>
</template>

<script>
import { genericErrorMessage, toast } from "@/keys/toast-messages";
export default {
  data() {
    return {
      transactionEdit: {},
      id: this.$route.params.id,
      genericErrorMessage,
      toast
    };
  },
  methods: {
    async getTransactionEditDetails() {
      try {
        this.$vs.loading({ background: "rgba(1,2,3,.2)" });
        // Get all transaction edits and find the matching one
        const result = await this.$axios.get(
          `${this.$ApiKeys.BASE_URL}/transactions/admin/edits?transactionId=${this.id}&perPage=15&page=1`
        );
        const data = result.data.data.nodes;

        this.$vs.loading.close();

        if (data.length > 0) {
          this.transactionEdit = data[0] || {};
        } else {
          this.toast("Transaction edit not found");
        }
      } catch (error) {
        console.error("Failed to fetch transaction edit details", error);
        this.toast(this.genericErrorMessage());
        this.$vs.loading.close();
      }
    },
    async updateStatus(status) {
      this.$vs.loading({ background: "rgba(1,2,3,.2)" });
      try {
        await this.$axios.patch(
          `${this.$ApiKeys.BASE_URL}/transactions/admin/edits/${this.id}`,
          { status }
        );
        this.toast(`Transaction edit ${status} successfully`);
        this.$vs.loading.close();
        this.getTransactionEditDetails();
      } catch (error) {
        this.toast(this.genericErrorMessage());
        this.$vs.loading.close();
      }
    },
    formatDate(date) {
      return new Date(date).toLocaleString();
    }
  },
  mounted() {
    this.getTransactionEditDetails();
  }
};
</script>

<style>
@import "./style.css";
</style>
